import styled from "@emotion/styled";
import { MenuItem } from "@mui/material";

import { ContextMenu, MenuItemLabel } from "../popup";
import { canvasToolbarButtonSize } from "./CanvasToolbar";

type Props = {
  actions: Array<{
    id: string;
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
  }>;
};

export const CanvasToolbarContextMenu = ({ actions }: Props) => {
  return (
    <StyledContextMenu data-test="toolbar-context-menu">
      {actions.map(({ id, icon, label, onClick }) => (
        <StyledMenuItem
          key={id}
          data-test="toolbar-context-menu-item"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          {icon}
          <MenuItemLabel>{label}</MenuItemLabel>
        </StyledMenuItem>
      ))}
    </StyledContextMenu>
  );
};

const StyledContextMenu = styled(ContextMenu)`
  font-size: 14px;
  height: ${canvasToolbarButtonSize}px;
  width: ${canvasToolbarButtonSize}px;
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 4px 10px;
  margin: 0 0 2px;
  display: grid;
  grid-template-columns: 18px 1fr;
  grid-column-gap: 4px;
  font-size: ${({ theme }) => theme.fontSize};
  i {
    text-align: center;
  }
`;
